import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal, Spin } from "antd";
import Modal from "react-modal";
import { useAuth } from "../../../store/auth";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const AgentCallList = (props) => {
  const { orgData } = useAuth();
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const [deleteLoading, setDeleteLoading] = useState(false);

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, agentCallServiceId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Agent Call detail?",
      onOk() {
        const data = {
          agentCallServiceId: agentCallServiceId,
          createdBy: parseInt(localStorage.getItem("id")),
        };

        setDeleteLoading(data);
        deleteOperation(
          {
            url: `/api/agentCallService/`,
            method: "DELETE",
            body: data,
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
            }

            if (data.error) {
              toast.error(data.error);
            }
            setDeleteLoading(false);
            FillDetail();
          },
          (error) => {
            toast.error(error);
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const { sendRequest: getFarmerData } = useHttp();

  const FillDetail = () => {
    getFarmerData(
      {
        url: `/api/agentCallService/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          const sortedData = res.sort((a, b) => b.farmerId - a.farmerId);
          setData(sortedData);
          setAllData(sortedData);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getFarmerData]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    var filetrtext = e.target.value.trim()?.toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.areaName?.toLowerCase().includes(filetrtext) ||
        item.farmerName?.toLowerCase().includes(filetrtext) ||
        item.identificationNo?.toLowerCase().includes(filetrtext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "800px", // Adjust the width as needed
      height: "550px",
      minHeight: "550px",
      overflow: "auto",
      //  border: "5px solid #96dc00",
    },
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    if (data) {
      setSelectedData(data);
      console.log(data);
    }

    setIsModalOpen(true);
  };

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const { sendRequest: getPdfData } = useHttp();

  const viewPdf = (data) => {
    setPdfView(true);

    setPdfData(data);
    console.log(data);
  };

  const generatePDF = async (docNo) => {
    const input = pdfContainerRef.current;

    const pdfName = docNo || "";
    if (input) {
      try {
        const canvas = await html2canvas(input, {
          scale: 2, // High resolution
          useCORS: true, // Enable cross-origin handling
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("portrait", "pt", "a4");

        const imgWidth = 595.28; // A4 width in points
        const pageHeight = 841.89; // A4 height in points
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        // Add the first page
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // Handle multi-page PDFs
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        pdf.save(`${pdfName}.pdf`);
      } catch (error) {
        console.error("Error generating PDF:", error);
        alert(
          "Failed to generate PDF. Please check the images or console for errors."
        );
      }
    }
  };

  return (
    <>
      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3 my-4" ref={pdfContainerRef}>
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      <div className="invoice p-3 mb-3">
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              <img
                                src={`${process.env.REACT_APP_FILE_URL}${
                                  orgData && orgData.organizationIcon
                                }`}
                                //   src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
                                width="50"
                                height="50"
                                alt=""
                              />
                              &nbsp;Agent Daily Call Detail
                            </h4>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-6">
                            <table className="table table-bordered">
                              <tbody className="text-right">
                                <tr>
                                  <th>Date:</th>
                                  <td>
                                    {" "}
                                    {pdfData && pdfData.agentCallServiceDate}
                                  </td>
                                </tr>

                                <tr>
                                  <th style={{ width: "50%" }}>Farmer Name:</th>
                                  <td> {pdfData && pdfData.farmerName}</td>
                                </tr>
                                <tr>
                                  <th style={{ width: "50%" }}>
                                    Employee Name:
                                  </th>
                                  <td> {pdfData && pdfData.employeeName}</td>
                                </tr>
                                <tr>
                                  <th style={{ width: "50%" }}>Paid Amount:</th>
                                  <td> {pdfData && pdfData.paidAmount}</td>
                                </tr>
                                <tr>
                                  <th style={{ width: "50%" }}>
                                    Client Reached/Unreached:
                                  </th>
                                  <td>
                                    {" "}
                                    {pdfData && pdfData.clientReachedUnreached}
                                  </td>
                                </tr>
                                <tr>
                                  <th style={{ width: "50%" }}>Remark/Note:</th>
                                  <td> {pdfData && pdfData.remarkNote}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive ">
                              <table className="table table-bordered">
                                <tbody className="text-right">
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Doc Number:
                                    </th>
                                    <td> {pdfData && pdfData.docNo}</td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>Farmer No:</th>
                                    <td> {pdfData && pdfData.farmerNo}</td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Outstanding Loan:
                                    </th>
                                    <td>
                                      {" "}
                                      {pdfData && pdfData.outstandingLoan}
                                    </td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Balance Amount:
                                    </th>
                                    <td> {pdfData && pdfData.balanceAmount}</td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>Response:</th>
                                    <td> {pdfData && pdfData.response}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() =>
                  generatePDF(pdfData && pdfData.agentCallServiceId)
                }
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
      {/* <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">
              <b>Agent Daily Call Detail</b>
            </h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr style={{ border: "1px solid black" }} />
            </div>

            <div className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Date:</label>
                      <p>{selectedData.agentCallServiceDate}</p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Doc Number:</label>
                      <p>{selectedData.docNo}</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Farmer Name:</label>
                      <p>{selectedData.farmerName}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Farmer No:</label>
                      <p>{selectedData.farmerNo}</p>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group">
                      <label>Employee Name:</label>
                      <p>{selectedData.employeeName}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group">
                      <label>Outstanding Loan:</label>
                      <p>{selectedData.outstandingLoan}</p>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group">
                      <label>Paid Amount:</label>
                      <p>{selectedData.paidAmount}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Balance Amount:</label>
                      <p>{selectedData.balanceAmount}</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group">
                      <label>Client Reached/Unreached:</label>
                      <p>{selectedData.clientReachedUnreached}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Response:</label>
                      <p>{selectedData.response}</p>
                    </div>
                  </div>
                </div>

                <div className="row">
              
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group">
                      <label>Remark/Note:</label>
                      <p>{selectedData.remarkNote}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal> */}

      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-9">
            <label className="card-title  my-3">
              {" "}
              &nbsp; &nbsp;Agent Daily Call Details
            </label>{" "}
          </div>
          <div className="col-md-3">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Agent Call Detail
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center table-responsive">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Farmer Name</th>
                            <th>Doc No</th>
                            <th>Field Executive</th>
                            <th>Outstanding Loan</th>
                            <th>Client Status</th>
                            <th>Paid Amount</th>
                            <th>Balance Amount</th>
                            <th>View</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.agentCallServiceDate}</td>
                                <td>{x.farmerName}</td>
                                <td>{x.docNo}</td>
                                <td>{x.employeeName}</td>
                                <td>{x.outstandingLoan}</td>
                                <td>{x.clientReachedUnreached}</td>
                                <td>{x.paidAmount}</td>
                                <td>{x.balanceAmount}</td>

                                <td>
                                  <button
                                    type="button"
                                    onClick={() => viewPdf(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  {deleteLoading === x ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        handleDelete(e, x.agentCallServiceId)
                                      }
                                      className="btn"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgentCallList;
